import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import NoServiceIcon from '../../Images/noServiceIcon2.svg';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../../Config';

function NoServicePage() {
  const handleLinkClick = (event) => {
    event.preventDefault();
    buildUrlAndOpenWindow(Config.internetSaleLink);
  };

  return (
    <div>
      <div className='no-service-page'>
        <div className='no-service-icon'>
          <Image src={NoServiceIcon} className='icon' alt='No Service Icon' />
        </div>
        <div className='title'>מצטערים, אנחנו לא מזהים שיש לכם שירות אינטרנט ב{window.Config.brand_Name_HE}</div>
        <div className='sub-title'>יכול להיות שנרשמתם עם פרטים אחרים? שווה לנסות להתחבר שוב</div>
        <div className='join-service'>
          <a href='#' className='join-service-button' onClick={handleLinkClick}>
            לחצו כאן להצטרפות לשירות
          </a>
        </div>
        <div className='retry-button'>
          <BtnSubmit
            className='btn-submit'
            isBusiness={false}
            text={'חזרה לאיזור האישי'}
            formid='error-page'
            isDisplayArrows={false}
            onclick={() => EpiContext.navigateTo(Config.lobbyUrl)}
          />
        </div>
      </div>
    </div>
  );
}

export default NoServicePage;
